
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ContractType } from "@/lib/types";
import { ContractFormValues } from "../ContractFormSchema";

import { CostCurrencySection } from "./CostCurrencySection";
import { PaymentScheduleSection } from "./PaymentScheduleSection";
import { ContractDatesSection } from "./ContractDatesSection";
import { useFeatureAccess } from "@/hooks/useFeatureAccess";
import { FeatureGuard } from "@/components/common/FeatureGuard";

interface ContractFinancialDetailsSectionProps {
  form: UseFormReturn<ContractFormValues>;
  selectedContractType: ContractType | null;
  renewalDate: Date | null;
  setCurrencyModalOpen: (open: boolean) => void;
  servicesTotal?: number;
}

export function ContractFinancialDetailsSection({
  form,
  selectedContractType,
  renewalDate,
  setCurrencyModalOpen,
  servicesTotal
}: ContractFinancialDetailsSectionProps) {
  const { t } = useTranslation();
  const { canUsePaymentTypeSelection } = useFeatureAccess();

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-medium">{t("Financial Details")}</h3>
        <p className="text-sm text-muted-foreground">
          {t("Cost and payment information")}
        </p>
      </div>

      <CostCurrencySection 
        form={form} 
        selectedContractType={selectedContractType} 
        setCurrencyModalOpen={setCurrencyModalOpen}
        servicesTotal={servicesTotal}
      />

      <FeatureGuard feature="payment_type_selection">
        <PaymentScheduleSection form={form} />
      </FeatureGuard>

      <ContractDatesSection 
        form={form} 
        selectedContractType={selectedContractType} 
        renewalDate={renewalDate} 
      />
    </div>
  );
}
